import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeliveryServiceType as LinkDeliveryServiceType } from '../links/DeliveryServiceType';
import { type CourierSchedule as SchemaCourierSchedule } from '../schemas/CourierSchedule';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetCourierScheduleContentType = '' as const;
export type GetCourierScheduleRequest = void;
export type GetCourierScheduleResponses = LinkCommonErrorResponses & {
    /**
     * @description Courier schedule
     */
    '200': {
        'application/json': SchemaCourierSchedule;
    };
};
export type GetCourierScheduleResponseSuccess = GetCourierScheduleResponses['200']['application/json'];
export type GetCourierScheduleSearchParams = {
    warehouse_id?: string;
    address: string;
    service_type: LinkDeliveryServiceType;
};
export type GetCourierSchedulePathParameters = undefined;
export const GetCourierScheduleUrl = '/delivery/courier/schedule' as const;
export const GetCourierScheduleMethod = 'GET' as const;
export const getGetCourierScheduleUrl = (_params?: GetCourierSchedulePathParameters) => GetCourierScheduleUrl;
